// Vuex canvas UI penProperty store module

const propertys = [
  {
    id        : 'defaultPen',
    name      : 'Pen',
    lineColor : 'rgba(255,0,0,1)',
    lineWidth : 3,
    blur      : 0,
    alpha     : false,
    lineCap   : 'round',
    composite : 'source-over'
  },
  {
    id        : 'defaultEraser',
    name      : 'Eraser',
    lineColor : 'black',
    lineWidth : 10,
    blur      : 0,
    alpha     : 1,
    lineCap   : 'round',
    composite : 'destination-out'
  }
]

const defaultPropertys = JSON.stringify(propertys)

const state = {
  selecting   : propertys[0],
  selectingId : propertys[0].id,
  propertys   : propertys
}

const getters = {
  activeProperty : state => state.propertys.find(prop => prop.id === state.selectingId),
  penProperty    : state => state.propertys.find(prop => prop.id === state.selectingId),
  propertys      : state => state.propertys,

  // old
  lineColor : state => state.selecting.lineColor,
  lineWidth : state => state.selecting.lineWidth,
  blur      : state => state.selecting.blur,
  alpha     : state => state.selecting.alpha,
  lineCap   : state => state.selecting.lineCap,
  composite : state => state.selecting.composite,
  selecting : state => state.selecting
}

let temp = 0
const mutations = {
  updateProperty (state, {type, value}) {
    state.propertys.some(prop => {
      if (prop.id === state.selectingId) prop[type] = value
    })
  },
  // old
  changeName      (state, value) { state.selecting.name = value },
  changeLineColor (state, value) { state.selecting.lineColor = value },
  changeLineWidth (state, value) { state.selecting.lineWidth = value },
  changeblur      (state, value) { state.selecting.blur = value },
  changealpha     (state, value) { state.selecting.alpha = value },
  changeLineCap   (state, value) { state.selecting.lineCap = value },
  changeComposite (state, value) { state.selecting.composite = value },
  selectProperty  (state, value) {
    state.selectingId = value
  },
  copyPenproperty (state, name) {
    state.propertys.push({
      ...state.selecting,
      name : name,
      id   : ++temp
    })
  },
  removeProperty (state, id) {
    if (state.propertys.length === 1) return false
    state.propertys.some((prop, index, propertys) => {
      if (prop.id === id) {
        propertys.splice(index, 1)
        state.selecting = propertys[index - 1] || propertys[index]
      }
    })
  },
  resetPropertys (state) {
    state.propertys = JSON.parse(defaultPropertys)
    state.selecting = state.propertys[0]
  }
}

const actions = {
  changeLineColor ({commit}, value) { commit('changeLineColor', value) },
  changeLineWidth ({commit}, value) { commit('changeLineWidth', value) },
  changeblur      ({commit}, value) { commit('changeblur', value) },
  changealpha     ({commit}, value) { commit('changealpha', value) }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/components/canvas/store/penProperty.js